import React from 'react'
import { useSidebarContext } from '../scenes/global/sidebar/SidebarContext'
import FinancialSummary from './FinancialSummary'

const FinancialSummaryPage = () => {
  const { theme } = useSidebarContext()

  return (
    <div className={`min-h-screen  transition-colors duration-300`}>
      <div className='container mx-auto px-4 py-6'>
        <div className='mb-6'>
          <h1 className={`text-3xl font-bold ${theme.tailwind.text9} mb-2`}>
            Financial Summary
          </h1>
          <p className={`${theme.tailwind.text10}`}>
            Comprehensive financial overview and analysis
          </p>
        </div>
        <FinancialSummary />
      </div>
    </div>
  )
}

export default FinancialSummaryPage
